// extracted by mini-css-extract-plugin
export default {"ShareSection":"ShareSection_ShareSection__PKYi+","download":"ShareSection_download__jUo7W","quiz":"ShareSection_quiz__0INf7","conversation":"ShareSection_conversation__UGr30"};